import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export type McpAccessScope = 'read_only' | 'read_write';

export interface McpAccessProfile {
  id: string;
  title: string;
  scope: McpAccessScope;
  expiresAt: string;
  lastUsedAt: string | null;
  lastUsedToolName: string | null;
  // Client-supplied and not content-sanitised by the API; must never be rendered as trusted markup.
  lastUsedClientName: string | null;
  createdAt: string;
  updatedAt: string;
  rateLimitPerMinute: number | null;
}

export interface McpAccessProfileWithToken extends McpAccessProfile {
  token: string;
}

export interface McpAccessProfileInput {
  title: string;
  scope: McpAccessScope;
}

export type McpAccessProfileUpdate = Partial<McpAccessProfileInput>;

const MCP_ACCESS_URL = `${API_SERVER_URL}/api/mcp-access`;
const JSON_HEADERS = { 'content-type': 'application/json' };

export const listMcpAccessProfiles = () =>
  apiService.callExternalApi<McpAccessProfile[]>({
    url: MCP_ACCESS_URL,
    method: 'GET',
    headers: JSON_HEADERS
  });

export const createMcpAccessProfile = (input: McpAccessProfileInput) =>
  apiService.callExternalApi<McpAccessProfileWithToken>({
    url: MCP_ACCESS_URL,
    method: 'POST',
    headers: JSON_HEADERS,
    data: input
  });

export const updateMcpAccessProfile = (id: string, update: McpAccessProfileUpdate) =>
  apiService.callExternalApi<McpAccessProfile>({
    url: `${MCP_ACCESS_URL}/${id}`,
    method: 'PATCH',
    headers: JSON_HEADERS,
    data: update
  });

export const rotateMcpAccessProfile = (id: string) =>
  apiService.callExternalApi<McpAccessProfileWithToken>({
    url: `${MCP_ACCESS_URL}/${id}/rotate`,
    method: 'POST',
    headers: JSON_HEADERS
  });

export const revokeMcpAccessProfile = (id: string) =>
  apiService.callExternalApi<void>({
    url: `${MCP_ACCESS_URL}/${id}`,
    method: 'DELETE',
    headers: JSON_HEADERS
  });
